var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('Layout',[_c('yn-header'),_vm._v(" "),_c('Layout',[_c('Sider',[_c('yn-slider')],1),_vm._v(" "),_c('Layout',{style:({paddingLeft: '20px'})},[_c('yn-tags'),_vm._v(" "),_c('Content',{style:({padding: '10px 20px', minHeight: '280px'})},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc8b80c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Index.vue
// module id = null
// module chunks = 